<template>
  <div class="RemovalConditions">
    <div class="RemovalConditions-title">
      <el-select
        v-model="logistic_business_id"
        filterable
        style="width: 20%"
        @change="logisticchange"
        placeholder="请选择集配中心"
      >
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>
    <div class="RemovalConditions-cnt">
      <div class="RemovalConditions-cnt-left">
        <div
          style="width: 100%; margin-bottom: 5px"
          v-for="item in firstlist"
          :key="item.id"
        >
          <el-button
            :type="firstlistindex == item.id ? 'primary' : ''"
            @click="firstlistclick(item)"
            style="width: 100%"
            >{{ item.name }}</el-button
          >
        </div>
      </div>
      <div class="RemovalConditions-cnt-right">
        <!-- 表单搜索 start -->
        <Filtersearch
          ref="Filtersearchref"
          :list="Filtersearchlist"
          :fromdata="formData"
          @Refresh="onHandleRefresh"
          @search="onSearch"
        >
          <template v-slot:left>
            <el-button type="primary" @click="setup">设置</el-button>
            <el-button type="primary" @click="Productwhitelist"
              >商品白名单</el-button
            >
          </template>
        </Filtersearch>
        <!-- 表单搜索 end -->
        <div class="auto-table-flex">
          <el-table
            :data="tableData"
            height="100%"
            v-loading="loading"
            :border="true"
            :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" align="center" width="100">
            </el-table-column>
            <el-table-column prop="name" align="center" label="品类名称">
            </el-table-column>
            <el-table-column
              prop="product_take_down_config.time_num_text"
              align="center"
              label="照片/视频更新时间"
            >
            </el-table-column>
            <el-table-column
              prop="product_take_down_config.inspection_report_pic_time_num_text"
              align="center"
              label="质检报告更新时间"
            >
            </el-table-column>
            <el-table-column
              prop="product_take_down_config.quality_percent"
              align="center"
              label="7天售后率"
            >
              <template slot-scope="scope">
                <div style="color: #999">
                  {{ scope.row.product_take_down_config.quality_percent }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="product_take_down_config.apply_percent"
              align="center"
              label="3天发起率"
            >
              <template slot-scope="scope">
                <div style="color: #999">
                  {{ scope.row.product_take_down_config.apply_percent }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="product_take_down_config.aftersale_percent"
              align="center"
              label="超售后率下架
"
            >
            </el-table-column>
            <el-table-column
              prop="product_take_down_config.sale_num"
              align="center"
              label="销量判断（件）"
            >
            </el-table-column>
            <el-table-column
              prop="product_take_down_config.shelf_life"
              align="center"
              label="保质期信息"
            >
              <template slot-scope="scope">
                <el-button
                  @click="viewShelfLife(scope.row)"
                  type="text"
                  style="color: #e6a23c"
                  >查看</el-button>
              </template>
            </el-table-column>
            <el-table-column
              prop="product_take_down_config.sales_10_day"
              align="center"
              label="近10日商品日均销量（件）"
            >
            </el-table-column>
            <el-table-column
              prop=""
              align="center"
              label="配置项"
              
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  v-if="scope.row.product_take_down_config.is_set == 1"
                  style="color: #e6a23c"
                  >单独配置</el-button
                >
                <div v-else>---</div>
              </template>
            </el-table-column>
            <el-table-column
              prop=""
              align="center"
              label="操作"
              
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  :disabled="scope.row.product_take_down_config.is_set != 1"
                  @click="del(scope.row)"
                  >移除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="fy">
          <el-pagination
            type="primary"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="formData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <setupitem ref="setupitemref" @setup="getfirstlist"></setupitem>

    <!-- 查看保质期信息弹窗 -->
    <el-dialog
      title="保质期信息"
      :visible.sync="shelfLifeDialogVisible"
      :close-on-click-modal="false"
      width="50%"
      center
    >
      <div style="padding: 20px;">
        <!-- 短期 -->
        <div style="margin-bottom: 20px;">
          <div style="font-weight: bold; margin-bottom: 10px;">
            保质期天数：&nbsp;&nbsp;保质期≤30天
          </div>
          <el-form label-width="170px">
            <el-form-item label="保质期更新时间：">
              <el-input
                v-model="shelfLifeData.short_cycle_value_text"
                style="width: 200px;"
                readonly
              ></el-input>
              <span style="margin-left: 20px;">{{ shelfLifeData.short_cycle_unit_text }}</span>
            </el-form-item>
            <el-form-item label="不可上架时间：">
              <el-input
                v-model="shelfLifeData.short_shelf_life_unlist_days"
                style="width: 200px;"
                readonly
              ></el-input>
              <span style="margin-left: 10px;">天</span>
            </el-form-item>
            <el-form-item label="临期标签显示时间：">
              <el-input
                v-model="shelfLifeData.short_shelf_life_show_days"
                style="width: 200px;"
                readonly
              ></el-input>
              <span style="margin-left: 10px;">天</span>
            </el-form-item>
          </el-form>
        </div>

        <!-- 中期 -->
        <div style="margin-bottom: 20px;">
          <div style="font-weight: bold; margin-bottom: 10px;">
            保质期天数：&nbsp;&nbsp;30天 &lt; 保质期≤6个月
          </div>
          <el-form label-width="170px">
            <el-form-item label="保质期更新时间：">
              <el-input
                v-model="shelfLifeData.medium_cycle_value_text"
                style="width: 200px;"
                readonly
              ></el-input>
              <span style="margin-left: 20px;">{{ shelfLifeData.medium_cycle_unit_text }}</span>
            </el-form-item>
            <el-form-item label="不可上架时间：">
              <el-input
                v-model="shelfLifeData.medium_shelf_life_unlist_days"
                style="width: 200px;"
                readonly
              ></el-input>
              <span style="margin-left: 10px;">天</span>
            </el-form-item>
            <el-form-item label="临期标签显示时间：">
              <el-input
                v-model="shelfLifeData.medium_shelf_life_show_days"
                style="width: 200px;"
                readonly
              ></el-input>
              <span style="margin-left: 10px;">天</span>
            </el-form-item>
          </el-form>
        </div>

        <!-- 长期 -->
        <div>
          <div style="font-weight: bold; margin-bottom: 10px;">
            保质期天数：&nbsp;&nbsp;保质期 &gt; 6个月
          </div>
          <el-form label-width="170px">
            <el-form-item label="保质期更新时间：">
              <el-input
                v-model="shelfLifeData.long_cycle_value_text"
                style="width: 200px;"
                readonly
              ></el-input>
              <span style="margin-left: 20px;">{{ shelfLifeData.long_cycle_unit_text }}</span>
            </el-form-item>
            <el-form-item label="不可上架时间：">
              <el-input
                v-model="shelfLifeData.long_shelf_life_unlist_days"
                style="width: 200px;"
                readonly
              ></el-input>
              <span style="margin-left: 10px;">天</span>
            </el-form-item>
            <el-form-item label="临期标签显示时间：">
              <el-input
                v-model="shelfLifeData.long_shelf_life_show_days"
                style="width: 200px;"
                readonly
              ></el-input>
              <span style="margin-left: 10px;">天</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shelfLifeDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import Filtersearch from "@/components/Filtersearch.vue";
import setupitem from "./modules/setup.vue";
export default {
  name: "RemovalConditions",
  components: { Filtersearch, setupitem },
  data() {
    return {
      options: [],
      logistic_business_id: "",
      firstlist: [],
      firstlistindex: 0,
      total: 0,
      currentPage: 0,
      loading: false,
      tableData: [],
      formData: {
        name: "",
        logistic_business_id: "", //	T文本	是	集配中心id
        aftersale_percent_min: "", //	T文本	是	最小售后率
        aftersale_percent_max: "", //	T文本	是	最大售后率
        first_cid: "", //	T文本	是	一级分类
        page: 1,
        pageSize: 100,
      }, // 表单参数
      formDataClone: {}, // 表单参数拷贝，用于重置
      Filtersearchlist: [
        {
          type: "input",
          name: "品类名称",
          clearable: true,
          model: "name",
          placeholder: "请输入品类名称",
        },
        {
          type: "maxinput",
          name: "超售后率",
          clearable: true,
          minmodel: "aftersale_percent_min",
          maxmodel: "aftersale_percent_max",
          placeholder: "请输入",
        },
      ],
      multipleSelection: [],
      shelfLifeDialogVisible: false,
      shelfLifeData: {},
    };
  },
  mounted() {
    this.formDataClone = cloneDeep(this.formData);
    this.getcollective();
  },

  methods: {
    del(e) {
      this.$confirm("确定要移除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$api.examine
            .downconfigremove({
              logistic_business_id:
                e.product_take_down_config.logistic_business_id,
              cid: e.product_take_down_config.cid,
            })
            .then((res) => {
              console.log(res, "停用或者开启");
              this.$message({
                type: "success",
                message: "移除成功",
              });
              this.getfirstlist();
            });
        })
        .catch(() => {});
    },
    Productwhitelist() {
       sessionStorage.setItem("logistic_business_id", this.logistic_business_id);
      this.$router.push({
        path: `/Productwhitelist?logistic_business_id=${this.logistic_business_id}`,
      });
    },
    setup() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: "请选择至少一个品类",
          type: "error",
        });
        return;
      }
      this.$refs.setupitemref.oninit(
        this.multipleSelection,
        this.logistic_business_id
      );
      console.log(this.multipleSelection, "sadasf");
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    firstlistclick(e) {
      this.firstlistindex = e.id;
      this.formData.first_cid = this.firstlistindex;
      this.getdownconfiglist();
    },
    /**
     * 重置表单，并刷新
     */
    onHandleRefresh() {
      this.formData = {
        ...this.formDataClone,
      };
      this.formData.logistic_business_id = this.logistic_business_id;
      this.formData.first_cid = this.firstlistindex;
      this.getdownconfiglist();
    },
    /**
     * 搜索表单
     */
    onSearch(e) {
      this.formData = e;
      this.formData.page = 1;
      this.getdownconfiglist();
    },
    handleSizeChange(val) {
      //   console.log(`每页 ${val} 条`);
      this.formData.pageSize = val;
      this.getdownconfiglist();
    },
    handleCurrentChange(val) {
      this.formData.page = val;
      this.currentPage = val;
      this.getdownconfiglist();
    },
    getdownconfiglist() {
      this.loading = true;
      this.$api.examine.downconfiglist(this.formData).then((res) => {
        console.log(res);
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.loading = false;
      });
    },
    getfirstlist() {
      this.$api.examine
        .firstlist({ logistic_business_id: this.logistic_business_id })
        .then((res) => {
          this.firstlist = res.data;
          this.firstlistindex = res.data[0] ? res.data[0].id : 0;
          this.formData.first_cid = this.firstlistindex;
          this.getdownconfiglist();
        });
    },
    logisticchange() {
      this.$api.decoration.collective({ is_online: 1 }).then((res) => {
        this.options = res.data;
        this.formData.logistic_business_id = this.logistic_business_id;
        this.getfirstlist();
      });
    },
    getcollective() {
      this.$api.decoration.collective({ is_online: 1 }).then((res) => {
        this.options = res.data;
        this.logistic_business_id = res.data[0].id;
        this.formData.logistic_business_id = this.logistic_business_id;
        this.getfirstlist();
      });
    },
    viewShelfLife(row) {
      const config = row.product_take_down_config || {};
      this.shelfLifeData = {
        short_cycle_value_text: config.short_cycle_value || '',
        short_cycle_unit_text: config.short_cycle_unit === 1 ? '日' : config.short_cycle_unit === 2 ? '月' : config.short_cycle_unit === 3 ? '年' : '',
        short_shelf_life_unlist_days: config.short_shelf_life_unlist_days || '',
        short_shelf_life_show_days: config.short_shelf_life_show_days || '',
        medium_cycle_value_text: config.medium_cycle_value || '',
        medium_cycle_unit_text: config.medium_cycle_unit === 1 ? '日' : config.medium_cycle_unit === 2 ? '月' : config.medium_cycle_unit === 3 ? '年' : '',
        medium_shelf_life_unlist_days: config.medium_shelf_life_unlist_days || '',
        medium_shelf_life_show_days: config.medium_shelf_life_show_days || '',
        long_cycle_value_text: config.long_cycle_value || '',
        long_cycle_unit_text: config.long_cycle_unit === 1 ? '日' : config.long_cycle_unit === 2 ? '月' : config.long_cycle_unit === 3 ? '年' : '',
        long_shelf_life_unlist_days: config.long_shelf_life_unlist_days || '',
        long_shelf_life_show_days: config.long_shelf_life_show_days || '',
      };
      this.shelfLifeDialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.RemovalConditions {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  .RemovalConditions-title {
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
  }
  .RemovalConditions-cnt {
    flex-grow: 1;
    overflow-y: hidden;
    display: flex;
    margin-top: 10px;
    .RemovalConditions-cnt-left {
      width: 15%;
      height: 100%;
      background-color: #fff;
      margin-right: 10px;
      padding: 20px;
      overflow-y: auto;
      box-sizing: border-box;
    }
    .RemovalConditions-cnt-right {
      width: 85%;
      height: 100%;
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      .auto-table-flex {
        flex-grow: 1;
        overflow-y: hidden;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
